import sanitizeHtml from "sanitize-html";

const decodeTextEntities = (value) =>
  value
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#0*39;/g, "'")
    .replace(/&apos;/g, "'");

export const stringUtil = {
  prepareDangerousHTML: (html, { asText = false } = {}) => {
    if (typeof html !== "string" || html.trim() === "") return "";

    const clean = sanitizeHtml(html, {
      disallowedTagsMode: "discard",
      allowedTags: [
        "strong",
        "b",
        "em",
        "i",
        "u",
        "s",
        "sub",
        "sup",
        "br",
        "a",
        "p",
        "ul",
        "ol",
        "li",
      ],
      allowedAttributes: {
        a: ["href", "target", "rel"],
      },
      allowedSchemesByTag: {
        a: ["https"],
      },
    });

    return asText ? decodeTextEntities(clean) : clean;
  },

  toText(html) {
    return this.prepareDangerousHTML(html, { asText: true });
  },

  toBase64: (str) => {
    return btoa(String.fromCharCode(...new TextEncoder().encode(str)));
  },

  fromBase64: (base64) => {
    return new TextDecoder().decode(
      Uint8Array.from(atob(base64), (c) => c.charCodeAt(0)),
    );
  },
};
